<div #tooltipContainer class="tooltip-container" style="overflow-wrap: break-word"
     [class.visible]="visible"
     [class.animate]="animate"
     [class.pos-top]="position === 'top'"
     [class.pos-bottom]="position === 'bottom'"
     [class.pos-left]="position === 'left'"
     [class.pos-right]="position === 'right'"
     [style.left.px]="left" [style.top.px]="top"
     [style.background-color]="visible ? 'rgba(0,0,0,0.8)' : 'black'"
     [style.max-width.px]="maxWidth">
    @if (tooltip && tooltip.length > 0) {
        <div class="font-M fw-500" [innerHTML]="tooltip"></div>
    } @else {
        <ng-content></ng-content>
    }
    <div class="tooltip-pointer" [class]="'tooltip-' + position"
         [style.left]="position === 'bottom' || position === 'top' ? 'calc(50% - ' + (5 + delta) + 'px)' : position === 'right' ? '-5px' : ''"
         [style.right]="position === 'left' ? '-5px' : ''"
         [style.top]="position === 'left' || position === 'right' ? 'calc(50% - ' + (5 + delta) + 'px)' : position === 'bottom' ? '-5px' : ''"
         [style.bottom]="position === 'top' ? '-5px' : ''">
    </div>
</div>
